import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from "react-toastify";
import {
  Box,
  Typography,
  Card,
  CardContent,
  CircularProgress,
  Alert,
  TablePagination,
  Grid,
  Divider,
  useTheme
} from '@mui/material';
import Page from '../components/Page';
import JobSearchBar from '../components/jobs/JobSearchBar';
import JobTable from '../components/jobs/JobTable';
import JobDetailPanel from '../components/jobs/JobDetailPanel';
import FilterTabs from '../components/jobs/FilterTabs';
import Modal from '../components/common/Modal';
import Button from '../components/common/Button';
import { useJobContext } from '../contexts/JobContext';
import Key from '../clientVariables.json';

const JobValidation = () => {
  const theme = useTheme();  const {
    jobs,
    filteredJobs,
    activeTab,
    setActiveTab,
    selectedJob,
    setSelectedJob,
    isLoading,
    error,
    setError,
    fetchJobs,
    pagination,
    handlePageChange,
    handleChangeRowsPerPage
  } = useJobContext();

  const [isDetailPanelOpen, setIsDetailPanelOpen] = useState(false);
  const [remarkJobId, setRemarkJobId] = useState(null);
  const [isRemarkModalOpen, setIsRemarkModalOpen] = useState(false);
  const [remark, setRemark] = useState('');
  // We'll use the pagination total count instead of just the current page jobs
  // Removed tab counts as per requirements
  // Filter jobs and update API query when tab changes
  useEffect(() => {
    // Reset pagination to first page when changing tabs
    fetchJobs({
      page: 0,
      rowsPerPage: pagination.rowsPerPage,
      status: activeTab !== 'all' ? activeTab : null
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab]);  // Handle search filters
  // Handle search filters
  const handleSearch = (filters) => {
    console.log("Search filters:", filters);

    // Add the active tab status to the search filters
    const searchParams = {
      ...filters,
      page: 0, // Reset to first page on new search
      rowsPerPage: pagination.rowsPerPage,
      status: activeTab !== 'all' ? activeTab : null
    };

    // Use the fetchJobs function from context to search in Solr with pagination
    fetchJobs(searchParams);
  };

  const handleViewDetails = (job) => {
    setSelectedJob(job);
    setIsDetailPanelOpen(true);
  };  const handleMarkValid = async (jobId) => {
    try {      
      const response = await axios.post(`${Key.domain}/common/verify-job`, {
        job_id: jobId,
        action: 'verify'
      });
      
      if (response.data.status) {
        // Update job status in context and refresh the job list
        fetchJobs({
          page: pagination.page,
          rowsPerPage: pagination.rowsPerPage,
          status: activeTab !== 'all' ? activeTab : null
        });

        // Show success notification
        toast.success('Job marked as valid successfully');
      }
    } catch (err) {
      console.error('Failed to verify job:', err);
      // Set error state to show in UI
      setError(err.response?.data?.message || 'Failed to verify job');
    }
  };
  const handleAddRemark = (jobId, existingRemark = '') => {
    // Pre-populate the remark field if an existing remark was provided
    setRemark(existingRemark);
    setRemarkJobId(jobId);
    setIsRemarkModalOpen(true);
  };const handleSubmitRemark = async () => {
    if (!remark.trim()) {
      setError('Remark cannot be empty');
      return;
    }
    
    try {
      const response = await axios.post(`${Key.domain}/common/verify-job`, {
        job_id: remarkJobId,
        action: 'remark',
        remark
      });
        if (response.data.status) {
        // Update status, store the remark, and refresh the job list
        fetchJobs({
          page: pagination.page,
          rowsPerPage: pagination.rowsPerPage,
          status: activeTab !== 'all' ? activeTab : null
        });
        
        // Show success notification
        toast.success('Remark added successfully');
        // Clear form fields
        setRemark('');
        // Close the modal
        setIsRemarkModalOpen(false);
      }
    } catch (err) {
      console.error('Failed to add remark:', err);
      setError(err.response?.data?.message || 'Failed to add remark');
    }
  };

  return (
    <Page title="Job Validation">
      <Grid sx={{ p: 3 }}>
        <Box sx={{ mb: 5 }}>
          {/* <Typography variant="h4" gutterBottom>
            Job Validation
          </Typography> */}
          {/* <Typography variant="body1" color="text.secondary">
            Search, review, and validate job listings from Solr.
          </Typography> */}
        </Box>        <Card sx={{ mb: 3 }}>
          <CardContent sx={{ p: { xs: 1, sm: 2 } }}>
            <JobSearchBar onSearch={handleSearch} />
          </CardContent>
        </Card>
        <FilterTabs
          activeTab={activeTab}
          onTabChange={setActiveTab}
        />

        {error && (
          <Alert severity="error" sx={{ mb: 3 }}>
            {error}
          </Alert>
        )}
        {isLoading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 5 }}>
            <CircularProgress />
          </Box>
        ) : (
          <>         
            <JobTable
            jobs={filteredJobs || jobs}
            onViewDetails={handleViewDetails}
            onMarkValid={handleMarkValid}
            onAddRemark={handleAddRemark}
          />            <Card sx={{ mt: 2, p: 1, boxShadow: 3, borderRadius: 2 }}>
              <Box sx={{ 
                display: 'flex', 
                flexDirection: { xs: 'column', md: 'row' },
                alignItems: 'center', 
                justifyContent: 'space-between',
                px: 2,
                py: 1
              }}>
                <Box sx={{ 
                  display: 'flex', 
                  alignItems: 'center',
                  mb: { xs: 2, md: 0 }
                }}>
                  <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mr: 1, color: theme.palette.primary.main }}>
                    Total Records: 
                  </Typography>
                  <Typography variant="subtitle1" sx={{ fontWeight: 'medium' }}>
                    {pagination.totalCount}
                  </Typography>
                </Box>
                
                <Divider orientation="vertical" flexItem sx={{ display: { xs: 'none', md: 'block' }, mx: 2 }} />
                
                <TablePagination
                  component="div"
                  count={pagination.totalCount}
                  page={pagination.page}
                  onPageChange={(e, newPage) => handlePageChange(newPage)}
                  rowsPerPage={pagination.rowsPerPage}
                  onRowsPerPageChange={(e) => handleChangeRowsPerPage(parseInt(e.target.value, 10))}
                  rowsPerPageOptions={[5, 10, 25, 50]}
                  labelRowsPerPage="Jobs per page:"
                  sx={{
                    '& .MuiTablePagination-toolbar': {
                      flexWrap: 'wrap',
                      justifyContent: 'center',
                    },
                    '& .MuiTablePagination-selectLabel, & .MuiTablePagination-select, & .MuiTablePagination-selectIcon, & .MuiTablePagination-input': {
                      fontSize: '14px',
                      fontWeight: 'medium',
                      color: theme.palette.text.primary,
                    },
                    '& .MuiTablePagination-actions': {
                      display: 'flex',
                      gap: 1,
                    },
                    '& .MuiButtonBase-root': {
                      backgroundColor: theme.palette.background.neutral || '#f5f5f5',
                      borderRadius: 1,
                      '&:hover': {
                        backgroundColor: theme.palette.action.hover || '#e0e0e0',
                      }
                    }
                  }}
                />
              </Box>
            </Card>
          </>
        )}        
        <JobDetailPanel
          job={selectedJob}
          isOpen={isDetailPanelOpen}
          onClose={() => setIsDetailPanelOpen(false)}
          onMarkValid={handleMarkValid}          onAddRemark={async (jobId, remarkText) => {
            try {
              const response = await axios.post(`${Key.domain}/common/verify-job`, {
                job_id: jobId,
                action: 'remark',
                remark: remarkText
              });
              
              if (response.data.status) {
                // Update job status in context and refresh the job list
                fetchJobs({
                  page: pagination.page,
                  rowsPerPage: pagination.rowsPerPage,
                  status: activeTab !== 'all' ? activeTab : null
                });
                
                toast.success('Remark added successfully');
              }
            } catch (err) {
              console.error('Failed to add remark:', err);
              setError(err.response?.data?.message || 'Failed to add remark');
            }
          }}
        />        <Modal
          isOpen={isRemarkModalOpen}
          onClose={() => setIsRemarkModalOpen(false)}
          title={remark.trim() ? "Update Remark" : "Add Remark"}
        >
          <Box>
            <Typography variant="subtitle2" mb={1}>
              Remark
            </Typography>
            <textarea
              style={{
                width: '100%',
                padding: '10px',
                borderRadius: '8px',
                border: '1px solid #ddd',
                minHeight: '100px'
              }}
              placeholder="Enter your remark about this job..."
              value={remark}
              onChange={(e) => setRemark(e.target.value)}
            />
            <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
              <Button
                variant="outlined"
                onClick={() => setIsRemarkModalOpen(false)}
              >
                Cancel
              </Button>
              <Button onClick={handleSubmitRemark}>
                Submit Remark
              </Button>
            </Box>
          </Box>
        </Modal>
      </Grid>
    </Page>
  );
};

export default JobValidation;
